/* Interviewee copies */
export const INTERVIEWEE_BOARD_COPY = {
  grid: {
    schedule: {
      display: 'Request a Mock Interview',
      desc: 'Mock interviews are the heart of interview preparation. Click on this card to request one and start practicing!',
    },
    incoming: {
      display: 'Incoming Interviews',
      desc: 'Check out your upcoming interviews. Prepare ahead of time.',
    },
    pasts: {
      display: 'Past Interviews',
      desc: 'Get insights from your previous interviews.',
    },
  },
};

export const INTERVIEWEE_PROFILE_COPY = {
  header: 'Nutri Profile',
  form: {
    schoolLabel: 'School',
    uploadResumeBtn: 'Load your resume',
    updateProfileBtn: 'Upload Profile',
  },
};

export const INTERVIEWEE_SCHEDULE_COPY = {
  header: 'Schedule Interview',
  form: {
    positionLabel: 'Position',
    roleLabel: 'Role applying to',
    numberOfInterviewsLabel: 'Number Of Interviews',
    programmingLabel: 'Programming languages to use in the interview',
    companyLabel: 'Company applying to',
    availabilityInfo:
      'In Proyecto Nutria we work with the Pacific Timezone, therefore you should provide your availability in PT (usually CDMX time -2 hours)',
    availabilityLabel: 'Add Availability Range',
    dayLabel: 'Day',
    startLabel: 'Start',
    endLabel: 'End',
    scheduleBtn: 'Schedule',
  },
};

/* Interviewer copies */
export const INTERVIEWER_POOL_COPY = {
  header: 'Match',
  table: {
    head: {
      languagesHead: 'Languages',
      awaitingHead: 'Requested',
      roleHead: 'Role',
      companyHead: 'Company',
      availabilityHead: 'Availability',
    },
    body: {
      docBtn: 'Resume',
      scheduleBtn: 'Schedule',
    },
  },
};

export const INTERVIEWER_PROFILE_COPY = {
  text: `
  By clicking on this box you give Proyecto Nutria the permission to share
  brief details on the way your are contributing to this project. See
  examples on our official website`,
  form: {
    mentionLabel: 'Mention',
    descriptionLabel: 'Your brief description',
    updateBtn: 'Update Information',
  },
};

export const INTERVIEWER_BOARD_COPY = {
  grid: {
    match: {
      display: 'Match',
      desc: 'Select your availability and match with someone else to have a mock interview.',
    },
    incoming: {
      display: 'Incoming Interviews',
      desc: 'Check out your upcoming interviews. Prepare ahead of time.',
    },
    pasts: {
      display: 'Past Interviews',
      desc: 'Get insights from your previous interviews.',
    },
  },
};

/* User copies */
export const PAST_INTERVIEWS_COPY = {
  header: 'Past Interviews',
  table: {
    head: {
      dateHead: 'Date',
      documentHead: 'Document URL',
    },
    body: {
      docBtn: 'Document',
    },
  },
};

export const INCOMING_INTERVIEWS_COPY = {
  header: 'Incoming Interviews',
  table: {
    head: {
      dayHead: 'Date (YYYY-MM-DD)',
      hourHead: 'Time in PT (24hrs)',
      documentHead: 'Document',
      roomHead: 'Discord Room',
      confirmed: 'Confirmed',
    },
    body: {
      confirmBtn: 'Confirm',
      cancelBtn: 'Cancel',
    },
  },
};
